import './product-features.component.pug'
import './product-features.component.scss'

import { adaptiveSwiper } from '../../application/application/adaptive-swiper'
import { Swiper, Pagination } from 'swiper'
Swiper.use([Pagination])

const swiperElement = document.querySelector(
  '.product-features-slider.swiper-container '
)
if (swiperElement) {
  adaptiveSwiper(Swiper, {
    swiperElement,
    settings: {
      autoHeight: true,
      pagination: {
        el: swiperElement.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true
      }
    },
    mediaQuery: '(min-width: 1025px)'
  })
}
